import V1 from '../../constants/v1-api-constant';
import apiClient from "../../gateway/api-gateway";

interface ResponseData { };

async function getAuthUser(): Promise<ResponseData> {
    const response = await apiClient.get(V1.auth);
    return response?.data?.data?.authentication;
}

const AuthService = {
    getAuthUser,
};
export default AuthService;
